/* ============================================
 BYTE-PAGE-ADDRESS.JS
 ============================================ */

(async function () {
  const root = document.querySelector('[data-byte-page-address-root]');
  if (!root) return;

  const STOREFRONT_TOKEN = root.getAttribute('data-storefront-token') || '';
  const SHOP_DOMAIN = root.getAttribute('data-shop-domain') || '';
  const API_URL = SHOP_DOMAIN ? `https://${SHOP_DOMAIN}/api/2026-01/graphql.json` : '';
  const LS_KEY = 'byte_page_addresses_v1';

  const CUSTOMER_EMAIL = root.getAttribute('data-customer-email') || '';
  const CUSTOMER_PHONE_RAW = root.getAttribute('data-customer-phone-raw') || '';

  const ILLER_URL = root.getAttribute('data-iller-url') || '';
  const ILCELER_URL = root.getAttribute('data-ilceler-url') || '';

  let illerData = [];
  let ilcelerData = [];

  async function loadLocationJson() {
    if (!ILLER_URL || !ILCELER_URL) return;
    try {
      const [r1, r2] = await Promise.all([fetch(ILLER_URL), fetch(ILCELER_URL)]);
      if (r1.ok) illerData = await r1.json();
      if (r2.ok) ilcelerData = await r2.json();
      if (!Array.isArray(illerData)) illerData = [];
      if (!Array.isArray(ilcelerData)) ilcelerData = [];
    } catch (err) {
      console.error(err);
    }
  }

  await loadLocationJson();

  function normEq(a, b) {
    const x = (a || '').toString().trim().toLocaleUpperCase('tr');
    const y = (b || '').toString().trim().toLocaleUpperCase('tr');
    return x === y;
  }

  function populateIlceForSehir(sehirId, selectedIlceId) {
    const ilceSel = document.getElementById('ilce');
    if (!ilceSel) return;

    if (!sehirId) {
      ilceSel.innerHTML = '<option value="">Önce il seçin</option>';
      ilceSel.disabled = true;
      return;
    }

    const list = ilcelerData.filter(x => String(x.sehir_id) === String(sehirId));
    list.sort((a, b) => a.ilce_adi.localeCompare(b.ilce_adi, 'tr'));
    ilceSel.innerHTML = '<option value="">İlçe seçin</option>';
    for (const d of list) {
      const opt = document.createElement('option');
      opt.value = String(d.ilce_id);
      opt.textContent = d.ilce_adi;
      ilceSel.appendChild(opt);
    }
    ilceSel.disabled = false;
    if (selectedIlceId != null && String(selectedIlceId).trim() !== '') {
      ilceSel.value = String(selectedIlceId);
    }
  }

  function initLocationSelects() {
    const ilSel = document.getElementById('il');
    const ilceSel = document.getElementById('ilce');
    if (!ilSel || !ilceSel || !illerData.length) return;

    const sorted = [...illerData].sort((a, b) => a.sehir_adi.localeCompare(b.sehir_adi, 'tr'));
    ilSel.innerHTML = '<option value="">İl seçin</option>';
    for (const s of sorted) {
      const opt = document.createElement('option');
      opt.value = String(s.sehir_id);
      opt.textContent = s.sehir_adi;
      ilSel.appendChild(opt);
    }

    ilSel.addEventListener('change', () => {
      populateIlceForSehir(ilSel.value, null);
    });
  }

  initLocationSelects();

  const customerAddressSeed = (() => {
    const el = root.querySelector('script[type="application/json"][data-byte-customer-addresses]');
    if (!el) return [];

    try {
      const data = JSON.parse((el.textContent || '').trim() || '[]');
      return Array.isArray(data) ? data : [];
    } catch (_) {
      return [];
    }
  })();

  function normalizeDigits(value) {
    return (value || '').toString().replace(/[^\d]/g, '');
  }

  function attachDigitsOnlyInput(id, maxLen) {
    const el = document.getElementById(id);
    if (!el) return;

    const apply = () => {
      const next = normalizeDigits(el.value);
      el.value = typeof maxLen === 'number' ? next.slice(0, maxLen) : next;
    };

    apply();
    el.addEventListener('input', apply);
    el.addEventListener('paste', () => setTimeout(apply, 0));
  }

  // TR telefonu E.164'e çevir: 05XX / 5XX / 905XX → +905XX
  function formatPhone(value) {
    let d = normalizeDigits(value);
    if (!d) return '';
    if (d.length >= 12 && d.startsWith('90')) d = d.slice(2);
    if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
    if (d.length > 10) d = d.slice(-10);
    return /^\d{10}$/.test(d) ? '+90' + d : '';
  }

  function uid() {
    return 'addr_' + Math.random().toString(16).slice(2) + Date.now().toString(16);
  }

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  function getCartToken() {
    return fetch('/cart.js').then(r => r.json()).then(c => c.token);
  }

  async function updateBuyerIdentity(cartToken, payload) {
    const mutation = `
      mutation cartBuyerIdentityUpdate($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
        cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
          cart { id checkoutUrl }
          userErrors { field message }
        }
      }
    `;

    const phoneE164 = formatPhone(payload.telefon);

    const deliveryAddress = {
      firstName: payload.ad,
      lastName: payload.soyad,
      address1: payload.adres,
      address2: payload.ilce || '',
      city: payload.il,
      province: payload.il,
      zip: payload.posta_kodu,
      country: 'TR',
      ...(phoneE164 ? { phone: phoneE164 } : {}),
    };

    const variables = {
      cartId: 'gid://shopify/Cart/' + cartToken,
      buyerIdentity: {
        email: payload.email,
        ...(phoneE164 ? { phone: phoneE164 } : {}),
        deliveryAddressPreferences: [{ deliveryAddress }],
      },
    };

    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
      },
      body: JSON.stringify({ query: mutation, variables }),
    });
    return response.json();
  }

  function loadStoredAddresses() {
    try {
      const s = JSON.parse(localStorage.getItem(LS_KEY) || '[]');
      return Array.isArray(s) ? s : [];
    } catch (_) {
      return [];
    }
  }

  function saveStoredAddresses(list) {
    localStorage.setItem(LS_KEY, JSON.stringify(
      (list || []).filter(a => a && a.source === 'local')
    ));
  }

  function buildCustomerAddresses() {
    return (customerAddressSeed || []).filter(Boolean).map(a => ({
      id: 'customer_' + String(a.id || uid()),
      shopifyId: String(a.id || ''),
      source: 'customer',
      adres_baslik: a.name || 'Adres',
      ad: a.first_name || '',
      soyad: a.last_name || '',
      il: a.province || a.city || '',
      ilce: a.city || '',
      adres: [a.address1, a.address2].filter(Boolean).join(' ').trim(),
      posta_kodu: a.zip || '',
      telefon: normalizeDigits(a.phone || ''),
      email: CUSTOMER_EMAIL || '',
      invoice_type: 'individual',
      tc_kimlik_no: '',
      vergi_dairesi: '',
      firma_adi: '',
      vergi_no: '',
    }));
  }

  function mergeAddressBook() {
    const merged = [...buildCustomerAddresses(), ...loadStoredAddresses()];
    const seen = new Set();
    return merged.filter(a => {
      if (!a || !a.id || seen.has(a.id)) return false;
      seen.add(a.id);
      return true;
    });
  }

  function formatAddressLine(a) {
    return [
      a.adres,
      [a.ilce, a.il, 'Türkiye'].filter(Boolean).join(' / '),
      [a.ad, a.soyad].filter(Boolean).join(' '),
      a.telefon ? '+90 ' + a.telefon : '',
    ].filter(Boolean).join(' — ');
  }

  let addresses = mergeAddressBook();
  let selectedAddressId = '';
  let editingAddressId = '';

  function setEmptyHintVisible(show) {
    const h = document.getElementById('address-empty-hint');
    if (h) h.classList.toggle('is-hidden', !show);
  }

  function renderAddressList() {
    const list = document.getElementById('address-list');
    const checkoutBtn = document.getElementById('checkout-btn');
    if (!list || !checkoutBtn) return;
    list.innerHTML = '';

    if (!addresses.length) {
      setEmptyHintVisible(true);
      checkoutBtn.disabled = true;
      return;
    }

    setEmptyHintVisible(false);

    if (!selectedAddressId || !addresses.some(x => x.id === selectedAddressId)) {
      selectedAddressId = addresses[0].id;
    }

    for (const a of addresses) {
      const row = document.createElement('div');
      row.className = 'address-item';
      row.innerHTML = `
        <input type="radio" name="selected_address" value="${escapeHtml(a.id)}"
          ${a.id === selectedAddressId ? 'checked' : ''} aria-label="${escapeHtml(a.adres_baslik)}">
        <div class="address-item__meta">
          <p class="address-item__title">${escapeHtml(a.adres_baslik || 'Adres')}</p>
          <p class="address-item__line">${escapeHtml(formatAddressLine(a))}</p>
          ${a.source === 'customer' ? '<span class="address-item__badge">Hesap adresi</span>' : ''}
        </div>
        <button type="button" class="address-item__edit" data-address-edit="${escapeHtml(a.id)}">Düzenle</button>
      `;
      list.appendChild(row);
    }

    checkoutBtn.disabled = !selectedAddressId;
  }

  function readForm() {
    const invoiceType = (document.querySelector('input[name="invoice_type"]:checked')?.value || 'individual').toString();
    const ilSel = document.getElementById('il');
    const ilceSel = document.getElementById('ilce');
    const ilId = ilSel?.value || '';
    const ilceId = ilceSel?.value || '';
    const ilRow = ilId ? illerData.find(s => String(s.sehir_id) === String(ilId)) : null;
    const ilceRow = ilceId ? ilcelerData.find(d => String(d.ilce_id) === String(ilceId)) : null;

    return {
      email: document.getElementById('email')?.value.trim() || '',
      telefon: normalizeDigits(document.getElementById('telefon')?.value || ''),
      adres_baslik: document.getElementById('adres_baslik')?.value.trim() || '',
      ad: document.getElementById('ad')?.value.trim() || '',
      soyad: document.getElementById('soyad')?.value.trim() || '',
      il: ilRow ? ilRow.sehir_adi.trim() : '',
      ilce: ilceRow ? ilceRow.ilce_adi.trim() : '',
      adres: document.getElementById('adres')?.value.trim() || '',
      invoice_type: invoiceType,
      tc_kimlik_no: normalizeDigits(document.getElementById('tc_kimlik_no')?.value || '').slice(0, 11),
      vergi_dairesi: (document.getElementById('vergi_dairesi')?.value || '').trim(),
      firma_adi: (document.getElementById('firma_adi')?.value || '').trim(),
      vergi_no: normalizeDigits(document.getElementById('vergi_no')?.value || '').slice(0, 11),
      posta_kodu: document.getElementById('posta_kodu')?.value.trim() || '',
    };
  }

  function fillForm(a) {
    const set = (id, v) => { const el = document.getElementById(id); if (el) el.value = v || ''; };
    set('email', a.email);
    set('telefon', a.telefon);
    set('adres_baslik', a.adres_baslik);
    set('ad', a.ad);
    set('soyad', a.soyad);

    const ilSel = document.getElementById('il');
    if (ilSel && illerData.length) {
      const ilMatch = illerData.find(s => normEq(s.sehir_adi, a.il));
      if (ilMatch) {
        ilSel.value = String(ilMatch.sehir_id);
        const districts = ilcelerData.filter(x => String(x.sehir_id) === String(ilMatch.sehir_id));
        const ilceMatch = districts.find(d => normEq(d.ilce_adi, a.ilce));
        populateIlceForSehir(ilMatch.sehir_id, ilceMatch ? String(ilceMatch.ilce_id) : '');
      } else {
        ilSel.value = '';
        populateIlceForSehir('', null);
      }
    }

    set('adres', a.adres);
    set('tc_kimlik_no', a.tc_kimlik_no);
    set('vergi_dairesi', a.vergi_dairesi);
    set('firma_adi', a.firma_adi);
    set('vergi_no', a.vergi_no);
    set('posta_kodu', a.posta_kodu);

    const invoiceType = (a.invoice_type || 'individual').toString();
    const radio = document.querySelector(`input[name="invoice_type"][value="${CSS.escape(invoiceType)}"]`);
    if (radio) radio.checked = true;
    applyInvoiceType(invoiceType);
  }

  function clearFormForNewAddress() {
    for (const id of ['adres_baslik', 'ad', 'soyad', 'adres', 'tc_kimlik_no', 'vergi_dairesi', 'firma_adi', 'vergi_no', 'posta_kodu']) {
      const el = document.getElementById(id);
      if (el) el.value = '';
    }

    const ilSel = document.getElementById('il');
    if (ilSel) ilSel.value = '';
    populateIlceForSehir('', null);

    editingAddressId = '';
    const btn = document.getElementById('btn-yazi');
    if (btn) btn.textContent = 'Oluştur';

    const radio = document.querySelector('input[name="invoice_type"][value="individual"]');
    if (radio) radio.checked = true;
    applyInvoiceType('individual');
  }

  function applyInvoiceType(type) {
    const t = (type || 'individual').toString();

    const individual = document.querySelector('[data-invoice-fields="individual"]');
    const corporate = document.querySelector('[data-invoice-fields="corporate"]');

    if (individual) {
      const show = t === 'individual';
      individual.classList.toggle('is-hidden', !show);
      individual.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) {
        individual.querySelectorAll('.is-error').forEach(el => el.classList.remove('is-error'));
      }
    }

    if (corporate) {
      const show = t === 'corporate';
      corporate.classList.toggle('is-hidden', !show);
      corporate.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!show) {
        corporate.querySelectorAll('.is-error').forEach(el => el.classList.remove('is-error'));
      }
    }
  }

  function validateForm() {
    const zorunlu = ['email', 'telefon', 'adres_baslik', 'ad', 'soyad', 'il', 'ilce', 'adres'];
    let gecerli = true;

    for (const id of zorunlu) {
      const el = document.getElementById(id);
      if (!el || !el.value.trim()) {
        const target = id === 'telefon' ? document.querySelector('.phone-input') : el;
        target?.classList.add('is-error');
        gecerli = false;
      } else {
        const target = id === 'telefon' ? document.querySelector('.phone-input') : el;
        target?.classList.remove('is-error');
      }
    }

    if (normalizeDigits(document.getElementById('telefon')?.value || '').length < 10) {
      document.querySelector('.phone-input')?.classList.add('is-error');
      gecerli = false;
    }

    const invoiceType = (document.querySelector('input[name="invoice_type"]:checked')?.value || 'individual').toString();
    if (invoiceType === 'corporate') {
      const requiredIds = ['vergi_dairesi', 'firma_adi', 'vergi_no'];
      for (const id of requiredIds) {
        const el = document.getElementById(id);
        if (!el || !el.value.trim()) {
          el?.classList.add('is-error');
          gecerli = false;
        } else {
          el.classList.remove('is-error');
        }
      }

      const vn = normalizeDigits(document.getElementById('vergi_no')?.value || '');
      if (vn.length < 10 || vn.length > 11) {
        document.getElementById('vergi_no')?.classList.add('is-error');
        gecerli = false;
      }
    } else {
      const tc = normalizeDigits(document.getElementById('tc_kimlik_no')?.value || '');
      if (tc.length !== 11) {
        document.getElementById('tc_kimlik_no')?.classList.add('is-error');
        gecerli = false;
      } else {
        document.getElementById('tc_kimlik_no')?.classList.remove('is-error');
      }
    }

    return gecerli;
  }

  async function setCartAttributes(invoice) {
    const type = invoice?.invoice_type === 'corporate' ? 'Kurumsal' : 'Bireysel';

    const attrs = {
      fatura_tipi: type,
    };

    if (invoice?.invoice_type === 'corporate') {
      attrs.vergi_dairesi = (invoice.vergi_dairesi || '').trim();
      attrs.firma_adi = (invoice.firma_adi || '').trim();
      attrs.vergi_no = normalizeDigits(invoice.vergi_no || '');
    } else {
      attrs.tc_kimlik_no = normalizeDigits(invoice?.tc_kimlik_no || '');
    }

    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    });

    if (!res.ok) throw new Error('Cart attributes update failed');
    return res.json();
  }

  function mesajGoster(tip, metin) {
    const el = document.getElementById('adres-mesaj');
    if (!el) return;
    el.className = 'address-message ' + (tip === 'basari' ? 'is-success' : 'is-error');
    el.textContent = metin;
    el.style.display = 'block';
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function btnDurum(yukleniyor) {
    const devam = document.getElementById('devam-btn');
    if (devam) devam.disabled = yukleniyor;

    const yazi = document.getElementById('btn-yazi');
    if (yazi) yazi.style.display = yukleniyor ? 'none' : 'inline';

    const yuklen = document.getElementById('btn-yuklen');
    if (yuklen) yuklen.style.display = yukleniyor ? 'inline' : 'none';
  }

  function checkoutBtnDurum(yukleniyor) {
    const btn = document.getElementById('checkout-btn');
    if (btn) btn.disabled = yukleniyor || !selectedAddressId;
  }

  (function prefill() {
    const emailEl = document.getElementById('email');
    if (emailEl && !emailEl.value.trim() && CUSTOMER_EMAIL) emailEl.value = CUSTOMER_EMAIL;

    const telEl = document.getElementById('telefon');
    if (telEl && !telEl.value.trim() && CUSTOMER_PHONE_RAW) {
      let d = normalizeDigits(CUSTOMER_PHONE_RAW);
      if (d.length >= 12 && d.startsWith('90')) d = d.slice(2);
      if (d.length === 11 && d.startsWith('0')) d = d.slice(1);
      if (d.length > 10) d = d.slice(-10);
      if (/^\d{10}$/.test(d)) telEl.value = d;
    }
  })();

  // Sayısal alanlar: yazarken sadece rakam
  attachDigitsOnlyInput('tc_kimlik_no', 11);
  attachDigitsOnlyInput('vergi_no', 11);
  attachDigitsOnlyInput('posta_kodu', 5);

  // İlk durum + değişiklik dinleme
  applyInvoiceType((document.querySelector('input[name="invoice_type"]:checked')?.value || 'individual').toString());
  document.addEventListener('change', (e) => {
    const r = e.target?.closest?.('input[name="invoice_type"]');
    if (!r) return;
    applyInvoiceType(r.value);
  });

  renderAddressList();

  document.getElementById('address-list')?.addEventListener('change', e => {
    const radio = e.target.closest('input[type="radio"][name="selected_address"]');
    if (!radio) return;
    selectedAddressId = radio.value;
    const btn = document.getElementById('checkout-btn');
    if (btn) btn.disabled = false;
  });

  document.getElementById('address-list')?.addEventListener('click', e => {
    const btn = e.target.closest('[data-address-edit]');
    if (!btn) return;
    const id = btn.getAttribute('data-address-edit');
    const a = addresses.find(x => x.id === id);
    if (!a) return;

    editingAddressId = a.id;
    fillForm(a);

    const yazi = document.getElementById('btn-yazi');
    if (yazi) yazi.textContent = 'Güncelle';

    mesajGoster('basari', 'Adres forma yüklendi. Değişikliklerinizi yapıp Güncelle butonuna basın.');
    document.getElementById('adres-form')?.scrollIntoView({ behavior: 'smooth' });
  });

  document.getElementById('adres-form')?.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validateForm()) {
      mesajGoster('hata', 'Lütfen tüm zorunlu alanları doğru şekilde doldurun.');
      return;
    }

    btnDurum(true);

    try {
      const formData = readForm();
      const record = {
        ...formData,
        id: editingAddressId || uid(),
        source: 'local',
      };

      if (editingAddressId) {
        addresses = addresses.map(a => a.id === editingAddressId ? record : a);
      } else {
        addresses = [record, ...addresses];
        selectedAddressId = record.id;
      }

      saveStoredAddresses(addresses);
      editingAddressId = '';
      renderAddressList();
      clearFormForNewAddress();
      mesajGoster('basari', 'Adres kaydedildi. Listeden seçip Ödemeye git ile devam edin.');
    } catch (err) {
      console.error(err);
      mesajGoster('hata', 'Bir hata oluştu. Lütfen tekrar deneyin.');
    } finally {
      btnDurum(false);
    }
  });

  document.getElementById('checkout-btn')?.addEventListener('click', async function () {
    const selected = addresses.find(a => a.id === selectedAddressId);
    if (!selected) {
      mesajGoster('hata', 'Lütfen listeden bir teslimat adresi seçin.');
      return;
    }

    const emailFromForm = document.getElementById('email')?.value.trim() || '';
    const resolvedEmail = emailFromForm || selected.email || CUSTOMER_EMAIL || '';

    const telefonFromForm = normalizeDigits(document.getElementById('telefon')?.value || '');
    const resolvedTelefon = telefonFromForm
      || normalizeDigits(selected.telefon || '')
      || normalizeDigits(CUSTOMER_PHONE_RAW || '');

    const payload = { ...selected, email: resolvedEmail, telefon: resolvedTelefon };

    if (!payload.email) {
      mesajGoster('hata', 'Ödeme için e-posta gereklidir.');
      document.getElementById('email')?.classList.add('is-error');
      return;
    }

    document.getElementById('email')?.classList.remove('is-error');
    checkoutBtnDurum(true);

    try {
      // Sipariş ek bilgileri (cart attributes)
      await setCartAttributes(payload);

      const cartToken = await getCartToken();
      if (!cartToken) {
        mesajGoster('hata', 'Sepetiniz bulunamadı. Lütfen sepete ürün ekleyip tekrar deneyin.');
        checkoutBtnDurum(false);
        return;
      }

      const sonuc = await updateBuyerIdentity(cartToken, payload);

      if (sonuc?.data?.cartBuyerIdentityUpdate?.userErrors?.length > 0) {
        const hata = sonuc.data.cartBuyerIdentityUpdate.userErrors[0].message;
        // Telefon hatası checkout'u engellemez, yine de yönlendir
        if (String(hata).toLowerCase().includes('phone')) {
          window.location.href = '/checkout';
          return;
        }

        mesajGoster('hata', 'Hata: ' + hata);
        checkoutBtnDurum(false);
        return;
      }

      const checkoutUrl = sonuc?.data?.cartBuyerIdentityUpdate?.cart?.checkoutUrl;
      window.location.href = checkoutUrl || '/checkout';

    } catch (err) {
      console.error(err);
      mesajGoster('hata', 'Bir hata oluştu. Lütfen tekrar deneyin.');
      checkoutBtnDurum(false);
    }
  });
})();

